import Cookies from "js-cookie";

export function saveToken(token) {
  const isHttps = window.location.protocol === "https:";
  Cookies.set("authToken", token, {
    expires: 1,
    secure: isHttps,
    sameSite: "Strict",
  });
}

export function saveUserName(userName) {
  Cookies.set("zerekUserName", userName, { expires: 1 });
}

export function saveFirstEntryValue(value) {
  Cookies.set("first_entry", value, { expires: 1 });
}

export function getUserName() {
  return Cookies.get("zerekUserName") || "";
}

export function removeToken() {
  Cookies.remove("authToken");
  Cookies.remove("zerekUserName");
  Cookies.remove("first_entry");
}

export function getToken() {
  return Cookies.get("authToken") || "";
}
